import React, { Component } from "react";
import { Box, ChakraProvider } from "@chakra-ui/react";
import { Switch, Route, Redirect } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";

import Sidebar from "../../components/Sidebar.jsx";
import Navbar from "../../components/Navbar.jsx";
import MainPage from "../../pages/Main/MainPage.jsx";
import AuthPage from "../../pages/Auth/AuthPage.jsx";
import ErrorPage from "../../pages/Error/ErrorPage.jsx";
import ModalAbout from "./Components/ModalAbout.jsx";

import "../../assets/css/admin.css";

import LocalStorageService from "../../services/LocalStorageService";

import UserSessionInfo from "../../models/UserSessionInfo";
import DeviceInfo from "../../components/lib/device/DeviceInfo";
import UserSessionKey from "../../models/UserSessionKey";
import JwtToken from "../../components/lib/tokens/JwtToken";

function isOnline() {
  return navigator.onLine;
}

export default class Admin extends Component {
  constructor(props) {
    super(props);

    this.deviceInfo = new DeviceInfo().getDeviceInfo();
    this.localStorageService = new LocalStorageService();

    let lastUserSession = this.localStorageService.hasLastUserSession()
      ? this.localStorageService.getLastUserSession()
      : {
          isValid: false,
          gcid: "",
          uid: "",
          name: "",
          title: "",
          token: "",
          offlineTokenCanExpire: true,
          allowedScopes: [],
          isAirplaneMode: false,
          currentLocationId: null,
          locationInfo: {},
        };

    this.state = {
      showFrames: false,
      systemErrorMsg: "",
      isLoggedIn: false,
      appInfo: {
        version: {
          build: "",
          dataIntApp: "",
          nabcCore: "",
          authCore: "",
        },
      },
      onlineInfo: {
        isOnline: false, // user has network access
        isAirplaneMode: false, // user WANTS to be disconnected, even if isOnline
        isConnected: false,
      }, // are we accessing network resources (because we are online AND NOT in Airplane mode)
      userSession: lastUserSession,
      userSessionKey: "",
      isAboutOpen: false
    };

    this.setFramesVisibility = this.setFramesVisibility.bind(this);

    this.onSuccessfulLogin = this.onSuccessfulLogin.bind(this);
    this.onLogoutRequest = this.onLogoutRequest.bind(this);

    this.onAboutOpen = this.onAboutOpen.bind(this);
    this.onAboutClose = this.onAboutClose.bind(this);
  }

  async componentDidMount() {
    // if I am connected, then I MUST log in.
    // if I am NOT connected, then I MUST have userSessionInfo stored.
    // AND if offlineTokenCanExpire is TRUE, then the token cannot have expired.
    let onlineInfo = isOnline()
      ? {
          isOnline: true, // user has network access
          isAirplaneMode: false, // user WANTS to be disconnected, even if isOnline
          isConnected: true,
        }
      : {
          isOnline: false, // user has network access
          isAirplaneMode: false, // user WANTS to be disconnected, even if isOnline
          isConnected: false,
        };
    this.setState({ onlineInfo: onlineInfo });

  
    // do we even HAVE a last userSession?
    if (!this.localStorageService.hasLastUserSession()) 
    {
      this.setState({
        systemErrorMsg:
          "No User Session has ever been established on this machine!",
      });
      this.setFramesVisibility(false);
      this.props.history.replace("/home/error-page");
      return;
    } 

    var userSession = this.localStorageService.getLastUserSession();
    var userSessionKey =
        UserSessionKey.fromUserSession(userSession).toQueryString();
    if (!JwtToken.isValidToken(userSession.token)) 
    {
        this.setFramesVisibility(false);
        this.setState({systemErrorMsg: "Last Saved user Session has an invalid Jwt Token!",});
        this.props.history.replace("/home/error-page");
        return;
    }
    //if (this.state.userSession.offlineTokenCanExpire) {
    if (JwtToken.isTokenExpired(userSession.token)) 
    {
        this.setState({
          systemErrorMsg:
            "The Last Saved user session Jwt token has expired and your organization does allow offline use with expired tokens!",
        });
        this.setFramesVisibility(false);
        this.props.history.replace("/home/error-page");
        return;
    }
      

    let appInfo = this.localStorageService.hasAppInfo(userSession.gcid,userSession.uid)
        ? this.localStorageService.getAppInfo(userSession.gcid, userSession.uid)
        : {
            version: {
              build: "",
              app: "",
              core: ""
            },
      };
      // if we got here then the user is OFFLINE AND is allowed to continue offline as the last user session
      this.setState({
        isLoggedIn: true,
        userSession: userSession,
        userSessionKey: userSessionKey,
        appInfo: appInfo,
      });
    
 
    this.addConnectionListeners();
    this.setFramesVisibility(true);
    this.props.history.replace("/home/home-page");
  }

  componentWillUnmount() {
    this.removeConnectionListeners();
  }

  setFramesVisibility(showFrames)
  {
    this.setState({showFrames: showFrames});
  }

  onHomePageRequest() 
  {
    this.setFramesVisibility(true);
    this.props.history.replace("/home/home-page");
  }

  onErrorPageRequest(msgs) {
    if (!msgs) {
      msgs = [""];
    }
    this.setFramesVisibility(false);
    this.setState({ framesystemErrorMsg: msgs.join(" ") });
    this.props.history.replace("/home/error-page");
  }

  async onSuccessfulLogin(loginInfo) {
    var userSession = {
      isValid: true,
      gcid: loginInfo.gcid,
      uid: loginInfo.uid,
      token: loginInfo.token,
      allowedLocations: loginInfo.allowedLocations,
      currentLocationId: "",
      locationInfo: loginInfo.currentWarehouse,
    };
    var appInfo = {
      version: {
        build: loginInfo.buildVer,
        app: loginInfo.appVer,
        core: loginInfo.coreVer
      },
    };
    var newUserSessionKey =
      UserSessionKey.fromUserSession(userSession).toQueryString();
    console.group(
      "In HomeLayout - onSuccessfulLogin after creating a userSession"
    );
    console.info(userSession);
    console.groupEnd();
    this.localStorageService.saveLastUserSession(userSession);
    this.setState({
      isLoggedIn: true,
      userSession: userSession,
      appInfo: appInfo,
      userSessionKey: newUserSessionKey, // needed to trigger header panel setting proper changed location
    });
    this.localStorageService.saveAppInfo(
      loginInfo.gcid,
      loginInfo.uid,
      appInfo
    );
    this.addConnectionListeners();
    this.setFramesVisibility(true);
    this.props.history.replace("/home/home-page");
  }

  onLogoutRequest() {
    console.log("Logging out...");
    // clean up
    this.removeConnectionListeners();
    this.localStorageService.removeLastUserSession();
    this.setFramesVisibility(false);
    this.props.history.replace("/home/auth-page");
  }

  addConnectionListeners() {
    window.addEventListener("online", this.handleConnectionChange);
    window.addEventListener("offline", this.handleConnectionChange);
  }

  removeConnectionListeners() {
    window.removeEventListener("online", this.handleConnectionChange);
    window.removeEventListener("offline", this.handleConnectionChange);
  }

  handleConnectionChange = () => {
    let onlineInfo = {};
    const condition = navigator.onLine ? "online" : "offline";
    onlineInfo.isOnline = condition === "online";
    onlineInfo.isConnected =
      onlineInfo.isAirplaneMode !== true && onlineInfo.isOnline;
    console.group("OnlineInfo Change:");
    console.info(onlineInfo);
    console.groupEnd();
    this.setState({ onlineInfo: onlineInfo });
    return onlineInfo;
  };

  onAboutOpen() {
    this.setState({ isAboutOpen: true });
  }

  onAboutClose() {
    this.setState({ isAboutOpen: false });
  }


  onUserGuideRequest()
  {
    window.open(
      "https://gcblobstoredurable1.blob.core.windows.net/userguidesdurable/glasschain-data-dashboard-userguide.pdf",
      "_blank"
    );
  }

  render() {
    return (
      <ChakraProvider>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <ModalAbout
          isOpen={this.state.isAboutOpen}
          onClose={this.onAboutClose}
          deviceInfo={this.deviceInfo}
          appInfo={this.state.appInfo}
          userSession={this.state.userSession}
        />

        <Navbar
          isVisible={this.state.showFrames}
          userSession={this.state.userSession}
          onAboutOpen={this.onAboutOpen}
          onLogoutRequest={this.onLogoutRequest}
          onUserGuideRequest={this.onUserGuideRequest}
        />

        <Sidebar 
          isVisible={this.state.showFrames}
          onAboutOpen={this.onAboutOpen} 
          onLogoutRequest={this.onLogoutRequest}
          onUserGuideRequest={this.onUserGuideRequest}
        />

        <Box className={(this.state.showFrames) ? "adminview": "adminview-hidden"}>

          <Switch>
            <Route
              path="/home/home-page"
              render={(props) => (
                <MainPage
                  {...props}
                  deviceInfo={this.deviceInfo}
                  appInfo={this.state.appInfo}
                  onlineInfo={this.state.onlineInfo}
                  userSession={this.state.userSession}
                  userSessionKey={this.state.userSessionKey} // used to trigger changes
                  onErrorPageRequest={this.onErrorPageRequest}
                  onHomePageRequest={this.onHomePageRequest}
                  onLogoutRequest={this.onLogoutRequest}
                  onToggleAirplaneMode={this.onToggleAirplaneMode}
                  onRefreshUserSessionKey={this.onRefreshUserSessionKey}
                />
              )}
            />
            <Route
              path="/home/auth-page"
              render={(props) => (
                <AuthPage
                  {...props}
                  deviceInfo={this.deviceInfo}
                  onSuccessfulLogin={this.onSuccessfulLogin}
                />
              )}
            />
            <Route
              path="/home/error-page"
              render={(props) => (
                <ErrorPage
                  {...props}
                  onLogoutRequest={this.onLogoutRequest}
                  systemErrorMsg={this.state.systemErrorMsg}
                />
              )}
            />
            <Redirect from="/" to="/home/home-page" />
            <Redirect from="/home" to="/home/home-page" />
          </Switch>

        </Box>
      </ChakraProvider>
    );
  }
}
